import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { BannerTrial } from "@similarweb/ui-components";

export const StyledBannerTrial = styled(BannerTrial)`
    padding: 10px 16px 16px 16px;
    border-radius: 0;
    box-shadow: none;
    margin-bottom: 0;
    p {
        &:first-of-type {
            margin-bottom: 4px;
            ${setFontVariant("subtitle1", colorsPalettes.indigo[300])};
        }

        &:last-of-type {
            ${setFontVariant("body2", colorsPalettes.indigo[300])};
            margin-bottom: 12px;
        }
    }
`;
